<div class="fixed top-4 right-4 space-y-2 z-50">
  <div *ngFor="let toast of toasts"
       [ngClass]="{
         'bg-green-500': toast.type === 'success',
         'bg-red-500': toast.type === 'error',
         'bg-blue-500': toast.type === 'info',
         'bg-yellow-500': toast.type === 'warning',
         'opacity-100 translate-x-0': toast.visible,
         'opacity-0 translate-x-5': !toast.visible
       }"
       class="text-white px-4 py-2 rounded shadow-lg transition-all duration-500 ease-in-out transform">
    {{ toast.text }}
  </div>
</div>
